export const TRANSITION_VARIANTS = {
  up: {
    hidden: { opacity: 0, y: '100%' },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: '100%' },
  },
  down: {
    hidden: { opacity: 0, y: '-100%' },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: '-100%' },
  },
  left: {
    hidden: { opacity: 0, x: '-100%' },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: '-100%' },
  },
  right: {
    hidden: { opacity: 0, x: '100%' },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: '100%' },
  },
};
